export const prodDomain = 'socialclubhub.app'
export const preferredTenantName = 'social'
export const saasServiceName = 'saas_' + preferredTenantName
export const adminemail = 'socialclubhub707@gmail.com'

// Candidate for value to come from server
export const sygnalApiEndpoint = 'https://socialchatsygnal.metcarob.com'
export const sygnalAppId = 'socialchat'

// Used in android version. Was confusing as it looks like a firebase ref to my old project
//  in future I will migrate over
export const sygnalAppIdLegacy = '1:1019430395417:android:d436938e1b527616be9488'
